import { useEffect, useMemo, useState } from 'react';
import { useStyles } from './styles';
import { CircularIndeterminate, Title } from '@utriper/core-ui';
import { useTranslation } from 'react-i18next';
import { Box, Grid2, Tab, Tabs } from '@mui/material';
import { useTraffic } from 'core/contexts/traffic';
import Layout from 'components/Layout';
import TrafficReport from './components/TrafficReport';
import VisitTab from './components/VisitTab';
import VisitsTableTab from './components/VisitsTableTab';
import VisitDailyTab from './components/VisitDailyTab';
import TrafficFilter from './components/TrafficFilter';

const TrafficPageContent = () => {
    const classes = useStyles();
    const { t: translate } = useTranslation();

    const DETAIL_VIEW = useMemo(
        () => ({
            OVERVIEW: 'overview',
            VISITS: 'visits',
            VISITS_TABLE: 'visitsTable',
            VISIT_DAILY: 'visitDaily',
        }),
        []
    );

    const { getDashboard, visits, visitsTable, visitDaily, loading } = useTraffic();
    const [detailView, setDetailView] = useState(DETAIL_VIEW.OVERVIEW);

    useEffect(() => {
        getDashboard();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleDetailViewChange = (event, newValue) => {
        setDetailView(newValue);
    };

    const visitsData = useMemo(() => {
        return visits ?? [];
    }, [visits]);

    const isDetailLoading = loading;

    return (
        <Layout contentClassName={classes.content}>
            <Grid2 container width="100%" direction="column" justifyContent="center" alignItems="flex-start" gap="16px" sx={{ color: '#131313' }}>
                <Title value={translate('traffic.title') || 'Traffic Analytics'} />
            </Grid2>

            <Grid2 container display={'flex'} width={'full'} size={12} marginBlock={1}>
                <TrafficFilter />
            </Grid2>

            <Grid2 container width="100%" justifyContent="flex-start" alignItems="center" mb={2}>
                <Tabs value={detailView} onChange={handleDetailViewChange} aria-label="traffic-detail-tabs" className={classes.tab}>
                    <Tab value={DETAIL_VIEW.OVERVIEW} label={translate('traffic.overview_tab') || 'Overview'} sx={{ fontWeight: 'bold' }} />
                    <Tab value={DETAIL_VIEW.VISITS_TABLE} label={translate('traffic.visitsTable_tab') || 'Visits Table'} sx={{ fontWeight: 'bold' }} />
                    <Tab value={DETAIL_VIEW.VISIT_DAILY} label={translate('traffic.visitDaily_tab') || 'Daily Visits'} sx={{ fontWeight: 'bold' }} />
                    <Tab value={DETAIL_VIEW.VISITS} label={translate('traffic.visits_tab') || 'Visits'} sx={{ fontWeight: 'bold' }} />
                </Tabs>
            </Grid2>

            {detailView === DETAIL_VIEW.OVERVIEW && <TrafficReport />}

            {detailView === DETAIL_VIEW.VISITS_TABLE &&
                (isDetailLoading ? (
                    <Box width="100%" display="flex" justifyContent="center" py={4}>
                        <CircularIndeterminate />
                    </Box>
                ) : (
                    <VisitsTableTab visitsTable={visitsTable} />
                ))}
            {detailView === DETAIL_VIEW.VISIT_DAILY &&
                (isDetailLoading ? (
                    <Box width="100%" display="flex" justifyContent="center" py={4}>
                        <CircularIndeterminate />
                    </Box>
                ) : (
                    <VisitDailyTab visitDaily={visitDaily} />
                ))}
            {detailView === DETAIL_VIEW.VISITS &&
                (isDetailLoading ? (
                    <Box width="100%" display="flex" justifyContent="center" py={4}>
                        <CircularIndeterminate />
                    </Box>
                ) : (
                    <VisitTab visits={visitsData} />
                ))}
        </Layout>
    );
};

const TrafficPage = () => {
    return <TrafficPageContent />;
};

TrafficPage.displayName = 'TrafficPage';

export default TrafficPage;
